module.exports = __webpack_public_path__ + "static/media/l.221d3d2a.png";